if (!customElements.get('ap-waluroll-options')) {
  customElements.define('ap-waluroll-options', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.closest('form');
      this.variants = JSON.parse(this.querySelector('[data-ap-main-variants]').textContent);
      this.money = new Intl.NumberFormat(this.dataset.locale || 'de-AT', { style: 'currency', currency: this.dataset.currency || 'EUR' });
      this.events = new AbortController();
      this.form.addEventListener('change', () => this.update(), { signal: this.events.signal });
      const section = document.getElementById(`MainProduct-${this.dataset.section}`);
      section.addEventListener('change', () => requestAnimationFrame(() => this.update()), { signal: this.events.signal });
      this.querySelectorAll('.ap-wr-info').forEach(info => {
        info.querySelector('summary').addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') info.open = true; }, { signal: this.events.signal });
        info.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') info.open = false; }, { signal: this.events.signal });
        info.addEventListener('keydown', event => { if (event.key === 'Escape') { info.open = false; info.querySelector('summary').focus(); } }, { signal: this.events.signal });
      });
      this.update();
    }
    disconnectedCallback() { this.events?.abort(); this.ready = false; }
    selectedAddons() { return [...this.querySelectorAll('[data-ap-addon]:checked:not(:disabled)')]; }
    currentVariant() { return this.variants.find(v => String(v.id) === this.form.elements.id.value); }
    update() {
      const poolType = this.querySelector('[data-ap-pooltype]');
      const specialPool = poolType && poolType.value !== '' && poolType.value !== 'Skimmerbecken';
      if (poolType) poolType.setCustomValidity(specialPool ? this.querySelector('[data-ap-overflow]').textContent.trim() : '');
      const overflowNote = this.querySelector('[data-ap-overflow]');
      if (overflowNote) overflowNote.hidden = !specialPool;
      const confirmation = this.querySelector('[data-ap-confirm]');
      const skimmerPool = poolType?.value === 'Skimmerbecken';
      if (confirmation) {
        const row = confirmation.closest('.ap-wr-confirm');
        row.hidden = !skimmerPool;
        row.style.display = skimmerPool ? '' : 'none';
        confirmation.disabled = !skimmerPool;
        confirmation.required = skimmerPool;
        if (!skimmerPool) confirmation.checked = false;
        const help = row.nextElementSibling;
        if (help?.classList.contains('ap-wr-help')) help.hidden = !skimmerPool;
      }
      const formError = this.closest('ap-waluroll-product-form')?.querySelector('.product-form__error-message-wrapper');
      if (!specialPool && overflowNote && formError?.querySelector('.product-form__error-message')?.textContent.trim() === overflowNote.textContent.trim()) {
        formError.hidden = true;
      }
      const quantity = Math.max(1, Number(this.form.elements.quantity?.value || 1));
      const total = ((this.currentVariant()?.price || 0) + this.selectedAddons().reduce((sum, input) => sum + Number(input.dataset.price), 0)) * quantity;
      const value = this.money.format(total / 100);
      this.querySelector('[data-ap-total]').textContent = value;
      document.querySelector('[data-ap-sticky-price]')?.replaceChildren(document.createTextNode(value));
      const colors = this.querySelector('[data-ap-bank-colors]');
      if (colors) {
        const wood = !!this.querySelector('[data-key="wood"]')?.checked;
        colors.hidden = wood;
        colors.querySelectorAll('input').forEach(input => input.disabled = wood);
      }
    }
    buildCartPayload(formData) {
      this.update();
      const poolType = this.querySelector('[data-ap-pooltype]');
      if (poolType && !poolType.checkValidity()) {
        poolType.reportValidity();
        throw new Error(this.querySelector('[data-ap-overflow]').textContent.trim());
      }
      if (this.querySelector('[data-ap-confirm]').required && !this.querySelector('[data-ap-confirm]').checked) {
        this.querySelector('[data-ap-confirm]').reportValidity();
        throw new Error(this.dataset.validation);
      }
      this.update();
      const variant = this.currentVariant();
      if (!variant?.available) throw new Error(this.dataset.error);
      const quantity = Number(formData.get('quantity') || 1);
      if (!Number.isSafeInteger(quantity) || quantity < 1) throw new Error(this.dataset.error);
      const properties = {};
      for (const [key,value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match) properties[match[1]] = value;
      }
      const addons = this.selectedAddons();
      const configuration = crypto.randomUUID();
      if (addons.length) { properties._ap_walter_configuration = configuration; properties._ap_walter_ratio = '1'; }
      const items = [{ id: variant.id, quantity, properties }];
      for (const input of addons) items.push({ id: Number(input.dataset.variant), quantity, parent_id: variant.id, properties: { [this.dataset.forLabel]: `${this.dataset.productTitle} – ${variant.sku}`, _ap_walter_configuration: configuration, _ap_walter_parent_sku: variant.sku, _ap_walter_ratio: '1' } });
      return { items };
    }
  });
}
